export default __webpack_public_path__ + "static/media/cl02.13ad749d.jpg";